module.exports = __webpack_public_path__ + "dist/media/home-preview.1548021e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-preview.png
// module id = 357
// module chunks = 0